import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
var LeftNavLink = function (_a) {
    var pathTo = _a.pathTo, _b = _a.render, render = _b === void 0 ? null : _b, title = _a.title, _c = _a.icon, icon = _c === void 0 ? null : _c;
    if (render)
        return render({ pathTo: pathTo, title: title, icon: icon });
    return _jsx(Link, { to: pathTo, children: title });
};
export default LeftNavLink;
